import Layout from "../../components/Layout";
import { EditListBrowse } from "./components/EditListBrowse";
import { ListSettingsForm } from "./components/ListSettingsForm";
import { useEditList } from "./useEditList";

export default function EditList() {
    const page = useEditList();

    return (
        <Layout gray={true}>
            {/* Main page: filter column + settings sidebar */}
            <div className="grid grid-cols-1 lg:grid-cols-12">
                <EditListBrowse {...page.browseColumn} />
                <ListSettingsForm {...page.settings} />
            </div>
        </Layout>
    );
}
